import React from 'react';
import styled from 'styled-components';

const ServicesSection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-light);
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled.h2`
  font-family: 'Libre Baskerville', serif;
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 3rem;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled.div`
  background-color: var(--background-white);
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;
  
  img {
    height: 60px;
    opacity: 0.8;
  }
`;

const ServiceTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  color: var(--text-dark);
  text-align: center;
  padding: 0 1.5rem 1.5rem;
  line-height: 1.6;
`;

const Services = () => {
  const servicesData = [
    {
      id: 1,
      title: 'General Dentistry',
      description: 'Comprehensive checkups, cleanings, and preventative care to maintain your oral health.',
      icon: '/images/tooth.png',
    },
    {
      id: 2,
      title: 'Cosmetic Dentistry',
      description: 'Transform your smile with our range of cosmetic procedures including whitening and veneers.',
      icon: '/images/tooth.png',
    },
    {
      id: 4,
      title: 'Restorative Dentistry',
      description: 'Restore damaged or missing teeth with fillings, crowns, and bridges.',
      icon: '/images/tooth.png',
    }
  ];

  return (
    <ServicesSection id="services">
      <SectionContainer>
        <SectionTitle>Our Services</SectionTitle>
        
        <ServicesGrid>
          {servicesData.map(service => (
            <ServiceCard key={service.id}>
              <ServiceIcon>
                <img src={service.icon} alt={service.title} />
              </ServiceIcon>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceDescription>{service.description}</ServiceDescription>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </SectionContainer>
    </ServicesSection>
  );
};

export default Services; 